import { gql, useLazyQuery, useMutation, useQuery } from '@apollo/client'

export const FOLLOW_UP_AUTOMATIONS = gql`
  query FollowUpAutomations {
    outreachAutomations {
      available
      upgradeMessage
      dailyCap
      sentToday
      sendSchedule
      holdoutPercent
      results {
        periodDays
        outcomeWindowDays
        minComparisonSize
        byTrigger {
          trigger
          count
          repliedCount
          bookedCount
        }
        automated {
          count
          repliedCount
          bookedCount
        }
        heldOut {
          count
          repliedCount
          bookedCount
        }
        personalized {
          count
          repliedCount
          bookedCount
        }
        asIs {
          count
          repliedCount
          bookedCount
        }
      }
      rules {
        trigger
        enabled
        active
        delayDays
        defaultDelayDays
        maxDelayDays
      }
    }
    outreachTemplates {
      trigger
      body
      defaultBody
      isDefault
      mergeFields
      optionalMergeFields
    }
  }
`

export const PREVIEW_OUTREACH_RULE = gql`
  query PreviewOutreachRule($trigger: OutreachTrigger!, $delayDays: Int) {
    previewOutreachRule(trigger: $trigger, delayDays: $delayDays) {
      eligibleCount
      skippedCount
      dailyCap
      conversationsChecked
      students {
        reason
        body
        student {
          id
          firstName
          lastName
        }
      }
    }
  }
`

export const UPSERT_OUTREACH_RULE = gql`
  mutation UpsertOutreachRule(
    $trigger: OutreachTrigger!
    $enabled: Boolean
    $delayDays: Int
  ) {
    upsertOutreachRule(
      trigger: $trigger
      enabled: $enabled
      delayDays: $delayDays
    ) {
      success
      message
      rule {
        trigger
        enabled
        active
        delayDays
      }
    }
  }
`

export const UPDATE_OUTREACH_TEMPLATE = gql`
  mutation UpdateOutreachTemplate($trigger: OutreachTrigger!, $body: String) {
    updateOutreachTemplate(trigger: $trigger, body: $body) {
      success
      message
      template {
        trigger
        body
        isDefault
      }
    }
  }
`

export const useFollowUpAutomations = () => useQuery(FOLLOW_UP_AUTOMATIONS)

export const usePreviewOutreachRule = () => useLazyQuery(PREVIEW_OUTREACH_RULE)

export const useUpsertOutreachRule = () => useMutation(UPSERT_OUTREACH_RULE)

export const useUpdateOutreachTemplate = () =>
  useMutation(UPDATE_OUTREACH_TEMPLATE)
